import React, { FunctionComponent } from 'react'
import { WbIcon } from '@workbench/react/dist'
import cn from 'classnames'

export type ButtonSize = 'large' | 'medium' | 'small'
export type ButtonTheme = 'dark' | 'light'
export type ButtonVariant = 'primary' | 'secondary' | 'tertiary'

export interface ButtonProps {
  size?: ButtonSize
  theme?: ButtonTheme
  variant?: ButtonVariant
  className?: string
  loading?: boolean
  icon?: string
  disabled?: boolean
  children?: React.ReactNode
}

export const buttonClass = (
  variant?: ButtonVariant,
  size?: ButtonSize,
  className?: string
) =>
  cn(
    'wb-button',
    variant ? `wb-button--${variant}` : `wb-button--primary`,
    size ? `wb-button--${size}` : `wb-button--large`,
    className
  )

export const Button: FunctionComponent<
  ButtonProps & JSX.IntrinsicElements['button']
> = ({
  size = 'large',
  theme = 'light',
  variant = 'primary',
  className,
  loading,
  icon,
  children,
  ...buttonProps
}) => {
  return (
    <button
      type="button"
      className={buttonClass(variant, size, className)}
      {...buttonProps}
    >
      {icon && (
        <WbIcon name={icon} aria-hidden="true" className="wb-button__icon" />
      )}

      {children}
    </button>
  )
}
